// Module
var code = "<div class=\"widget-content\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <table class=\"wide-table-combined\"> <tbody> <tr ng-repeat=\"role in vm.roles\"> <td id=\"{{'id'+role.id}}\" wt-draggable> <span>{{role.name|translate}}</span> </td> </tr> </tbody> </table> </div>";
// Exports
module.exports = code;